const topics = [
  { label: '连载更新', hot: true },
  { label: '韩漫追更', hot: true },
  { label: '日漫连载', hot: false },
  { label: '国漫推荐', hot: true },
  { label: '都市言情', hot: false },
  { label: '奇幻冒险', hot: true },
  { label: '悬疑推理', hot: false },
  { label: '免费全集', hot: true },
  { label: '下拉式阅读', hot: false },
  { label: '新番速递', hot: true },
  { label: '完结推荐', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            探索当下最受热议的漫画话题，发现你的下一部必追佳作
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#index"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-800 hover:bg-primary-200 border border-primary-200'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}